import Dashboard from '../Components/Pages/Dashboard/index';
import SubscriptionPlans from '../Components/Pages/Product&ServiceManagement/SubscriptionManagement/SubscriptionPlans';
import SubscriptionFormPage from '../Components/Pages/Product&ServiceManagement/SubscriptionManagement/SubscriptionForm';
import ViewSubscribers from '../Components/Pages/Product&ServiceManagement/SubscriptionManagement/ViewSubscribers';
import ClassManagement from '../Components/Pages/Product&ServiceManagement/ClassManagement';
import ProductManagement from '../Components/Pages/Product&ServiceManagement/ProductManagement';
import MarketingManagement from '../Components/Pages/Product&ServiceManagement/BannerCampaignManagement';
import MerchantDetails from '../Components/Pages/MerchantDetails';
import MerchantPending from '../Components/Pages/MerchantPending/MerchantPending.jsx';
import MerchantDeclined from '../Components/Pages/MerchantDeclined/MerchantDeclined.jsx';
import MerchantDeleted from '../Components/Pages/MerchantDeleted/MerchantDeleted.jsx';
import OrderManagement from "../Components/Pages/OrderManagement/OrderManagement.jsx"
import RevenueAnalytics from "../Components/Pages/ReveneAnalytics/RevenueAnalytics.jsx"
import MerchantDetailPage from '../Components/Pages/MerchantDetailPage';
import Finance from '../Components/Pages/Finance/Finance.jsx';
import Subscriptions from '../Components/Pages/MySubscriptions/Subscriptions.jsx';
import Reviews from '../Components/Pages/Reviews/Reviews.jsx';
import SupportPage from '../Components/Pages/Support/SupportPage.jsx';
import NotificationsPage from '../Components/Pages/Notifications/NotificationPage.jsx';
import NotFoundPage from '../Components/Pages/NotFound/NotFound.jsx';
import Coach from '../Components/Pages/Coach/Coach.jsx';
import ForgetPwd from '../Components/Pages/Auth/ForgetPwd.jsx';

export const routes = [
  // //page
  { path: `/forget-password`, Component: <ForgetPwd /> },
  { path: `/pages/dashboard/`, Component: <Dashboard /> },
  { path: `/pages/coach/`, Component: <Coach /> },
  { path: `/subscription/plans/`, Component: <SubscriptionPlans /> },
  { path: `/subscription/add-edit/:id?`, Component: <SubscriptionFormPage /> },
  { path: `/subscription/subscribers/`, Component: < ViewSubscribers /> },
  { path: `/classes/class-management/`, Component: < ClassManagement /> },
  { path: `/products/product-management/`, Component: < ProductManagement /> },
  { path: `/page/orders/`, Component: < OrderManagement /> },
  { path: `/marketing/marketing-management/`, Component: < MarketingManagement /> },
  // { path: `/merchant/details/:edit?`, Component: < MerchantDetails /> },
  { path: `/merchant/pending/`, Component: < MerchantPending /> },
  { path: `/merchant/declined/`, Component: < MerchantDeclined /> },
  { path: `/merchant/deleted/`, Component: < MerchantDeleted /> },
  { path: `/merchant/profile`, Component: < MerchantDetailPage /> },
  { path: `/revenue/analytics`, Component: < RevenueAnalytics /> },
  { path: `/finance/finance-management`, Component: < Finance /> },
  { path: `/subscriptions/my-subscriptions/`, Component: < Subscriptions /> },
  { path: `/review/reviews`, Component: < Reviews /> },
  { path: `/page/faq's`, Component: < SupportPage /> },
  { path: `/page/notifications`, Component: < NotificationsPage /> },
  { path: `/*`, Component: <NotFoundPage /> },
];
